import "./App.css";

//import Login from "./Login";
// import { Route, Routes } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes ,Navigate } from 'react-router-dom'

import LienUtileAdmin from "./components/lienutile";

//import Dashboard from "./Dashboard";
import React, { useContext } from "react";
import { AppContext } from "./services/context";

//import Dashboard from "./components/dashboard/index";
import Dashboard from "./Dashboard";

// import Login from "./components/login";
import Reset from "./components/reset_password";

import Liste from "./components/interface_user/publication/listePublication";
import Membre from "./components/interface_user/membre/membre";

import ScrollToTop  from "./components/scroll/scrollToTop";

import ListeProjet from "./components/interface_user/projet/listeProjet";
import ListeInformation from "./components/interface_user/actualite/listeInformation";
import ListePublication from "./components/interface_user/publication/listePublication";


import DetailInformation from "./components/interface_user/actualite/detailInformation";

import DetailPublication from "./components/interface_user/publication/detail";

import PublicationUser from "./components/interface_user/publication/userPublication";

import MemberBureauCRUD from "./components/membreburreau";

import Apropos from "./components/interface_user/apropos/apropos";
import Contact from "./components/interface_user/contact/contact";
import Detail from "./components/interface_user/projet/detail";

import Login from "./components/interface_user/authentification/login";
import Inscription from "./components/interface_user/authentification/inscription";

import Informations from "./components/interface_user/actualite/inform";

import DetailProfile from "./components/interface_user/profile/detailProfile";

import Accueil from "./components/interface_user/home/index";
import Forum from "./components/interface_user/forum/forum";

import DiscussionDetail from "./components/interface_user/forum/DiscussionDetail";

import Register from "./components/register";
import Code from "./components/verification_code";
import CodeEmail from "./components/verification_code_mail";
import Contacts from "./components/contact";

import Projetadmin from "./components/projets";
import CategoriesAdmin from "./components/categories";
import InformationAdmin from "./components/informations";
import Publications from "./components/publications/indexAdmin";
import Profile from "./components/profileUser/Profile";

import Question from "./components/forums/indexAdmin";

import "aos/dist/aos.css";
import Partenaire from "./components/partenaire";
import ApiInterceptor from "./services/api";
import Besoins from "./components/interface_user/besoinsutilisateur/besoinsutilisateur";
import BesoinAdmin from "./components/besoin";
import CommentaireAdmin from "./components/commentaires";
import DetailProjets from "./components/profileUser/projetuser";
import DetailPublications from "./components/profileUser/publicationuser";

function App() {
  const authCtx = useContext(AppContext);
  const { onUserChange } = authCtx;
  const { user } = useContext(AppContext);


  return (
    <div className="row">

      <ApiInterceptor>
      <Routes>
        <Route path="/" element={<Accueil />} />

        <Route path="/admin/*" element={<Dashboard />} />
        {/* <Route
          path="/admin/*"
          element={
            user?.isAuth && user?.roles?.includes("ADMINISTRATEUR") ? (
                            <Dashboard />
            ) : (
              <Navigate to="/" replace />
            )
          }
        /> */}

        <Route path="/acceuil/inform" element={<Informations />} />
        <Route path="/acceuil/forum" element={<Forum />} />
        <Route path="/acceuil/membre" element={<Membre />} />
        <Route path="/mesprojets" element={<DetailProjets />} />
        <Route path="/mespublications" element={<DetailPublications />} />

        <Route path="/register" element={<Register />} />
        <Route path="/reset" element={<Reset />} />

        <Route path="/activation" element={<Code />} />

        <Route path="/verification" element={<CodeEmail />} />

        <Route path="/profileUser" element={<Profile />} />
        <Route path="/lienUtile" element={<LienUtileAdmin />} />

        <Route path="/projet/:projectId" element={<Detail />} />
        <Route path="/information/:informationId" element={<DetailInformation />} />
        <Route path="/publication/:publicationId" element={<DetailPublication />} />

        <Route path="/utilisateur/:profileId" element={<DetailProfile />} />

        <Route path="/liste" element={<Liste />} />

        <Route path="/userPublication" element={<PublicationUser />} />


        <Route path="/contacte" element={<Contacts />} />

        <Route path="/Projets" element={<ListeProjet />} />
        <Route path="/Informations" element={<ListeInformation />} />
        <Route path="/Publications" element={<ListePublication />} />



        <Route path="/contact" element={<Contact />} />
        <Route path="/apropos" element={<Apropos />} />
        <Route path="/inform" element={<Informations />} />

        <Route path="/loginUser" element={<Login />} />


        <Route path="/discussion/:questionId" element={<DiscussionDetail />} />

        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/acceuil/informations" element={<Informations />} />

        <Route path="/forum" element={<Question />} />

        <Route path="/forums" element={<Forum />} />
        <Route path="/partenaires" element={<Partenaire />} />

        <Route path="/projet" element={<Projetadmin />} />
        <Route path="/categorie" element={<CategoriesAdmin />} />
        <Route path="/information" element={<InformationAdmin />} />
        <Route path="/publication" element={<Publications />} />

        <Route path="/contacts" element={<Contacts />} />
        <Route path="/membreburreau" element={<MemberBureauCRUD/>} />
        <Route path="/besoin" element={<Besoins/>} />
        <Route path="/besoinadmin" element={<BesoinAdmin/>} />
        <Route path="/inscription" element={<Inscription/>} />
        <Route path="/commentaire" element={<CommentaireAdmin/>} />


      </Routes>

      </ApiInterceptor>

      <ScrollToTop />

    </div>
  );
}

export default App;
